var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var URL_DELIMETER = "___";
var NULL_STRING = '-Please Select-';

var BaseFinder = function (_React$Component) {
	_inherits(BaseFinder, _React$Component);

	function BaseFinder() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, BaseFinder);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BaseFinder.__proto__ || Object.getPrototypeOf(BaseFinder)).call.apply(_ref, [this].concat(args))), _this), _this._ignoreCookies = function () {
			var queryString = window.location.search;
			var urlParams = new URLSearchParams(queryString);
			return urlParams.has('no-cookie');
		}, _this._checkParams = function () {
			var queryString = window.location.search;
			var urlParams = new URLSearchParams(queryString);
			var maxFoundInARow = 0;
			var continueCounting = true;
			var foundParams = {};
			_this.queryParams.forEach(function (each, ind) {
				if (urlParams.get(each) && continueCounting) {
					maxFoundInARow++;
				} else {
					continueCounting = false;
				}
				foundParams[each] = urlParams.get(each);
			});
			foundParams['maxFoundInARow'] = maxFoundInARow;
			return foundParams;
		}, _this._parseSafe = function (item) {
			if (item && typeof item === 'string') {
				try {
					return JSON.parse(item);
				} catch (err) {
					return null;
				}
			}
			return null;
		}, _this._getOrderedIndex = function () {
			var continue_adding = true;
			var i = 0;
			_this.queryParams.forEach(function (each, ind) {
				var current_state_item_name = _this.paramStateMap[each];
				var current_state_item = _this.state[current_state_item_name];
				if (current_state_item && current_state_item.value !== NULL_STRING && continue_adding) {
					i++;
				} else {
					continue_adding = false;
				}
			});
			return i;
		}, _this.updateURL = function () {
			var urlParams = new URLSearchParams();
			var continue_adding = true;
			_this.queryParams.forEach(function (each) {
				var current_state_item_name = _this.paramStateMap[each];
				var current_state_item = _this.state[current_state_item_name];
				if (current_state_item && current_state_item.value !== NULL_STRING && continue_adding) {
					var readyValue = _this.prepareValuesForURL(current_state_item);
					urlParams.append(each, readyValue);
				} else {
					continue_adding = false;
				}
			});
			var str = "";
			var queryString = "";
			if (urlParams.toString() !== "") {
				str = location.pathname + "?" + urlParams.toString();
				queryString = "?" + urlParams.toString();
			} else {
				str = location.pathname;
			}
			window.history.replaceState(null, "", str);
			_this.setState({
				queryString: queryString
			});
		}, _this.prepareValuesForURL = function (values) {
			if (!values) return '';
			if (values.value !== values.text) {
				return values.value + URL_DELIMETER + values.text;
			} else {
				return values.value;
			}
		}, _this.prepareQueryParamForState = function (paramString) {
			// split string on delimiter
			var splitString = paramString.split(URL_DELIMETER);
			var value = "";
			var text = "";
			if (splitString.length > 1) {
				value = splitString[0];
				text = splitString[1];
			} else {
				value = splitString[0];
				text = splitString[0];
			}
			return {
				value: value,
				text: text
			};
		}, _this._getBreadCrumbHref = function (state_item_name, state_item) {
			var urlParams = new URLSearchParams();
			var continue_adding = true;
			_this.queryParams.forEach(function (each) {
				if (continue_adding) {
					var current_state_item_name = _this.paramStateMap[each];
					var current_state_item = _this.state[current_state_item_name];
					var readyValue = _this.prepareValuesForURL(current_state_item);
					if (current_state_item.value === NULL_STRING) {
						urlParams.delete(each);
					} else if (urlParams.has(each)) {
						urlParams.set(each, readyValue);
					} else {
						urlParams.append(each, readyValue);
					}
				}
				if (state_item_name === _this.paramStateMap[each]) {
					continue_adding = false;
				}
			});
			var str = "";
			if (urlParams.toString() !== "") {
				str = location.pathname + "?" + urlParams.toString();
			} else {
				str = location.pathname;
			}
			return str;
		}, _this._getBreadCrumb = function () {
			var CRUMB_DELIMITER = React.createElement(
				'span',
				{ className: 'crumb-delimiter' },
				'>'
			);
			var links = [];
			var index = 0;
			_this.queryParams.forEach(function (each, ind) {
				var state_item_name = _this.paramStateMap[each];
				var state_item = _this.state[state_item_name];
				if (state_item && state_item.value !== NULL_STRING) {
					var link_obj = {
						text: _this.queryParamLabels[ind + 1],
						value: state_item.value,
						link: _this._getBreadCrumbHref(state_item_name, state_item)
					};
					links.push(link_obj);
					index = ind;
				}
			});

			// disable last link in breadcrumb
			if (links.length > 1) {
				links[links.length - 1].link = '#';
			}
			var linksHTML = links.map(function (each) {
				return React.createElement(
					'a',
					{ href: each.link },
					each.text
				);
			});
			linksHTML.unshift(React.createElement(
				'a',
				{ href: location.href.replace(location.search, '?no-cookie') },
				_this.queryParamLabels[0]
			));
			if (_this.props.config.title) {
				linksHTML.unshift(React.createElement(
					'a',
					{ href: location.href.replace(location.search, '?no-cookie') },
					_this.props.config.title
				));
			}
			var final = [];
			linksHTML.forEach(function (each, ind, arr) {
				final.push(each);
				if (ind != arr.length - 1) {
					final.push(CRUMB_DELIMITER);
				}
			});
			return final;
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(BaseFinder, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			// check for cookies
			// set them in state
			// pass them down to select's
			var foundParams = this._checkParams();
			if (foundParams.maxFoundInARow > 0 || this._ignoreCookies()) {
				var newState = {};
				for (var i = 0; i < foundParams.maxFoundInARow; i++) {
					var param = this.queryParams[i];
					var paramValues = foundParams[param];
					var stateValue = this.prepareQueryParamForState(paramValues);
					newState[this.paramStateMap[param]] = stateValue;
				}
				this.setState(newState);
			} else {
				var vendor = this.props.config.vendor;

				var selectedYear = accessCookie(getCookieName(vendor, 'selectedYear'));
				var selectedHorsepowers = accessCookie(getCookieName(vendor, 'selectedHorsepowers'));
				var selectedModelNumber = accessCookie(getCookieName(vendor, 'selectedModelNumber'));
				var selectedComponent = accessCookie(getCookieName(vendor, 'selectedComponent'));

				selectedYear = this._parseSafe(selectedYear);
				selectedHorsepowers = this._parseSafe(selectedHorsepowers);
				selectedModelNumber = this._parseSafe(selectedModelNumber);
				selectedComponent = this._parseSafe(selectedComponent);

				this.setState({
					selectedYear: selectedYear,
					selectedHorsepowers: selectedHorsepowers,
					selectedModelNumber: selectedModelNumber,
					selectedComponent: selectedComponent
				}, this.updateURL);
			}
		}
	}]);

	return BaseFinder;
}(React.Component);

var SelectSearch = function (_React$Component2) {
	_inherits(SelectSearch, _React$Component2);

	function SelectSearch(props) {
		_classCallCheck(this, SelectSearch);

		var _this2 = _possibleConstructorReturn(this, (SelectSearch.__proto__ || Object.getPrototypeOf(SelectSearch)).call(this, props));

		_this2.optionChoose = function (e) {
			_this2.props.onChange({
				target: {
					value: e.target.value,
					text: e.target.innerText,
					name: _this2.props.name,
					extra: e.target.dataset.extra
				}
			});
			_this2.toggleDropdown();
		};

		_this2.filter = function (e) {
			var value = e.target.value;

			_this2.setState({
				filter: value.trim()
			});
		};

		_this2.toggleDropdown = function () {
			_this2.setState({
				dropdownHidden: !_this2.state.dropdownHidden
			});
		};

		_this2.abortController = new AbortController();
		_this2.signal = _this2.abortController.signal;
		_this2.state = {
			options: [],
			filter: '',
			dropdownHidden: true
		};
		return _this2;
	}

	_createClass(SelectSearch, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.getSelectOptions();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevProps.url != this.props.url) {
				this.getSelectOptions();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.abortController.abort();
		}
	}, {
		key: 'getSelectOptions',
		value: function getSelectOptions() {
			var _this3 = this;

			if (this.props.url) {
				fetch(this.props.url, { signal: this.signal }).then(handleErrors).then(function (data) {
					return data.json();
				}).then(function (data) {
					_this3.setState({
						options: data
					});
				}).catch(catchErrors);
			} else {
				if (this.state.options.length > 0) {
					this.setState({
						options: []
					});
				}
			}
		}
	}, {
		key: 'getOptions',
		value: function getOptions() {
			var _this4 = this;

			var preOptionsHook = this.props.preOptionsHook;
			var options = this.state.options;

			var rawOptions = preOptionsHook ? preOptionsHook(options) : options;
			var reconfiguredOptions = rawOptions.map(function (option) {
				if (typeof option === 'string') {
					return {
						value: option,
						text: option
					};
				} else {
					return option;
				}
			});
			var filteredOptions = reconfiguredOptions.filter(function (option) {
				if (typeof option.value === 'string') {
					return option.text.toLowerCase().indexOf(_this4.state.filter.toLowerCase()) > -1;
				} else {
					return option.labelOverride.toLowerCase().indexOf(_this4.state.filter.toLowerCase()) > -1;
				}
			});
			var finalOptions = filteredOptions.map(function (each, ind) {
				if (typeof each.value === 'string') {
					return React.createElement(
						'option',
						{
							value: each.value.trim(),
							key: each.value.trim() + '-' + ind,
							onClick: _this4.optionChoose
						},
						each.text
					);
				} else {
					return React.createElement(
						'option',
						{
							value: each.valueOverride.trim(),
							key: ind,
							'data-extra': each.extraData,
							onClick: _this4.optionChoose
						},
						each.labelOverride
					);
				}
			});
			finalOptions.unshift(React.createElement(
				'option',
				{ value: null, onClick: this.optionChoose },
				NULL_STRING
			));
			return finalOptions;
		}
	}, {
		key: 'render',
		value: function render() {
			var selectClass = 'selectDisplay dropdown-' + this.state.dropdownHidden;
			var title = this.props.title ? this.props.title : NULL_STRING;
			return React.createElement(
				'div',
				{ className: 'pf-selectContainer' },
				React.createElement(
					'label',
					null,
					this.props.label
				),
				React.createElement(
					'div',
					{
						name: this.props.name,
						onClick: this.toggleDropdown,
						className: selectClass
					},
					this.props.value && this.props.value.text ? this.props.value.text : title
				),
				React.createElement(
					'div',
					{
						className: 'pf-dropdown',
						style: { display: this.state.dropdownHidden ? 'none' : 'block' }
					},
					React.createElement('input', {
						placeholder: 'Search',
						onInput: this.filter
					}),
					React.createElement(
						'div',
						{ className: 'pf-dropdown-options' },
						this.state.options ? this.getOptions() : null
					)
				)
			);
		}
	}]);

	return SelectSearch;
}(React.Component);

var PartsDisplay = function (_React$Component3) {
	_inherits(PartsDisplay, _React$Component3);

	function PartsDisplay() {
		var _ref2;

		var _temp2, _this5, _ret2;

		_classCallCheck(this, PartsDisplay);

		for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
			args[_key2] = arguments[_key2];
		}

		return _ret2 = (_temp2 = (_this5 = _possibleConstructorReturn(this, (_ref2 = PartsDisplay.__proto__ || Object.getPrototypeOf(PartsDisplay)).call.apply(_ref2, [this].concat(args))), _this5), _this5.state = {
			parts: [],
			loading: true
		}, _this5.getImage = function () {
			var imageBase = "";
			var imageUrl = "";

			// set image base url
			if (_this5.props.api === 'brp') {
				imageBase = "https://api-brp.seawaymarine.com/seaway-media/Diagrams/BRP/"; //EvinrudeImages/41/279002/05.png
			} else if (_this5.props.api === 'partfinder2') {
				imageBase = "https://partfinder2.seawaymarine.com/seaway-media/Diagrams/";
				if (_this5.props.imageName) {
					imageUrl = imageBase + _this5.props.imageName;
					return imageUrl;
				}
			} else if (_this5.props.api === 'yamaha') {
				imageBase = 'https://api-brp.seawaymarine.com/seaway-media/Diagrams/Yamaha/';
			}

			if (_this5.state.parts.length > 0) {
				var vals = Object.values(_this5.state.parts[0]);
				var img = vals[0].image;
				imageUrl = imageBase + img;
				return imageUrl;
			}

			return null;
		}, _temp2), _possibleConstructorReturn(_this5, _ret2);
	}

	_createClass(PartsDisplay, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.getParts();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevProps.url != this.props.url) {
				this.getParts();
			}
		}
	}, {
		key: 'getParts',
		value: function getParts() {
			var _this6 = this;

			this.setState({ loading: true });
			if (this.props.url) {
				console.log('getting parts from this url: ' + this.props.url);
				fetch(this.props.url).then(handleErrors).then(function (data) {
					return data.json();
				}).then(function (data) {
					console.log("parts");
					console.log(data);
					_this6.setState({
						parts: data,
						loading: false
					});
				}).catch(catchErrors);
			} else {
				if (this.state.parts.length > 0) {
					this.setState({
						parts: [],
						loading: true
					});
				}
			}
		}
	}, {
		key: 'listParts',
		value: function listParts(isMobile) {
			var preOptionsHook = this.props.preOptionsHook;
			var parts = this.state.parts;

			var rawParts = preOptionsHook ? preOptionsHook(parts) : parts;
			var sortedParts = rawParts.sort(function (a, b) {
				var idA = Object.keys(a)[0];
				var idB = Object.keys(b)[0];
				return a[idA].referenceNumber - b[idB].referenceNumber;
			});
			var finalParts = sortedParts.map(function (each) {
				var id = Object.keys(each)[0];
				var data = each[id];
				if (isMobile) {
					return React.createElement(PartMobile, { key: id, data: data });
				} else {
					return React.createElement(Part, { key: id, data: data });
				}
			});
			return finalParts;
		}
	}, {
		key: 'render',
		value: function render() {
			var img = this.getImage();
			if (this.props.url) {
				if (this.state.loading) {
					return React.createElement('div', { className: 'spinner' });
				} else {
					return React.createElement(
						'div',
						{ className: 'partsTable' },
						React.createElement(
							'div',
							{ className: 'tableImageContainer' },
							img ? React.createElement('img', { src: img }) : null
						),
						React.createElement(
							'div',
							{ className: 'partRow partTitle hideMobile' },
							React.createElement(
								'div',
								{ className: 'refNum' },
								'Ref #'
							),
							React.createElement(
								'div',
								{ className: 'partNum' },
								'Part #'
							),
							React.createElement(
								'div',
								{ className: 'desc' },
								'Part Name'
							),
							React.createElement(
								'div',
								{ className: 'quantity' },
								'Quantity'
							),
							React.createElement(
								'div',
								{ className: 'stockStatus' },
								'Stock Status'
							),
							React.createElement(
								'div',
								{ className: 'price' },
								'Price'
							),
							React.createElement(
								'div',
								{ className: 'addToCart' },
								'Add to Cart'
							)
						),
						this.state.parts ? this.listParts(false) : React.createElement(
							'h1',
							{ className: 'hideMobile' },
							'Loading...'
						),
						this.state.parts ? this.listParts(true) : React.createElement(
							'h1',
							null,
							'Loading...'
						)
					);
				}
			} else {
				return null;
			}
		}
	}]);

	return PartsDisplay;
}(React.Component);

var Part = function (_React$Component4) {
	_inherits(Part, _React$Component4);

	function Part(props) {
		_classCallCheck(this, Part);

		var _this7 = _possibleConstructorReturn(this, (Part.__proto__ || Object.getPrototypeOf(Part)).call(this, props));

		_this7.state = { quantityInput: 1, actualQuantity: null, variantId: null };
		_this7.base = "https://www.seawaymarine.com/products/";
		_this7.variant_base = "https://seaway.fdgweb.net/PartFinder/inventory.php?variant=";

		_this7.updateQuantity = function (event) {
			var value = event.target.value;

			_this7.setState({
				quantityInput: parseInt(value) || 1
			});
		};

		_this7.addToCart = function () {
			var data = _this7.props.data;

			addItemToCart(_this7.state.quantityInput, data.partNumber);
		};

		_this7.abortController = new AbortController();
		_this7.signal = _this7.abortController.signal;
		return _this7;
	}

	_createClass(Part, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this8 = this;

			var data = this.props.data;

			if (data.partNumber) {
				var url = this.base + data.partNumber + '.js';
				var name = data.description;
				fetch(url, { signal: this.signal }).then(handleErrors).then(function (data) {
					return data.json();
				}).then(function (data) {
					_this8.setState(Object.assign({
						dataRef: JSON.stringify(data)
					}, data));
					var variantId = null;
					if (data.variants && data.variants.length === 1) {
						variantId = data.variants[0].id;
					}
					if (variantId) {
						fetch(_this8.variant_base + variantId).then(handleErrors).then(function (data) {
							return data.json();
						}).then(function (data) {
							console.log(name);
							if (variantId == 27133595091044) {
								console.log('product variant quantity', data.variant.inventory_quantity);
							}
							_this8.setState({
								actualQuantity: data.variant.inventory_quantity
							});
						});
					}
				}).catch(catchErrors);
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.abortController.abort();
		}
	}, {
		key: 'render',
		value: function render() {
			var data = this.props.data;
			var _state = this.state,
			    price = _state.price,
			    quantityInput = _state.quantityInput,
			    actualQuantity = _state.actualQuantity;

			var url = '/products/' + data.partNumber;
			var quantity = actualQuantity != undefined ? actualQuantity : data.quantity;
			console.log('render ' + data.description + ' quantity ' + quantity);
			return React.createElement(
				'div',
				{ className: 'partRowOuter hideMobile' },
				React.createElement(
					'div',
					{ className: 'partRow' },
					React.createElement(
						'div',
						{ className: 'refNum' },
						data.referenceNumber
					),
					React.createElement(
						'div',
						{ className: 'partNum' },
						data.partNumber
					),
					React.createElement(
						'div',
						{ className: 'desc' },
						React.createElement(
							'a',
							{ href: url },
							data.description
						)
					),
					React.createElement(
						'div',
						{ className: 'quantity' },
						price ? React.createElement('input', {
							type: 'number',
							min: '1',
							value: quantityInput,
							onChange: this.updateQuantity
						}) : 'NA'
					),
					React.createElement(
						'div',
						{ className: 'stockStatus' },
						price ? quantity > 0 ? "In Stock" : "Available" : ''
					),
					React.createElement(
						'div',
						{ className: 'price' },
						price ? formatMoney(price) : ''
					),
					React.createElement(
						'div',
						{ className: 'addToCart' },
						price && React.createElement('input', {
							id: 'addToCart',
							type: 'button',
							value: 'Add to Cart',
							onClick: this.addToCart
						})
					)
				)
			);
		}
	}]);

	return Part;
}(React.Component);

var PartMobile = function (_React$Component5) {
	_inherits(PartMobile, _React$Component5);

	function PartMobile(props) {
		_classCallCheck(this, PartMobile);

		var _this9 = _possibleConstructorReturn(this, (PartMobile.__proto__ || Object.getPrototypeOf(PartMobile)).call(this, props));

		_this9.state = { quantityInput: 1, actualQuantity: null, variantId: null };
		_this9.base = "https://www.seawaymarine.com/products/";
		_this9.variant_base = "https://seaway.fdgweb.net/PartFinder/inventory.php?variant=";

		_this9.updateQuantity = function (event) {
			var value = event.target.value;

			_this9.setState({
				quantityInput: parseInt(value) || 1
			});
		};

		_this9.addToCart = function () {
			var data = _this9.props.data;

			addItemToCart(_this9.state.quantityInput, data.partNumber);
		};

		_this9.abortController = new AbortController();
		_this9.signal = _this9.abortController.signal;
		return _this9;
	}

	_createClass(PartMobile, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this10 = this;

			var data = this.props.data;

			if (data.partNumber) {
				var url = this.base + data.partNumber + '.js';
				var name = data.description;
				fetch(url, { signal: this.signal }).then(handleErrors).then(function (data) {
					return data.json();
				}).then(function (data) {
					_this10.setState(Object.assign({
						dataRef: JSON.stringify(data)
					}, data));
					var variantId = null;
					if (data.variants && data.variants.length === 1) {
						variantId = data.variants[0].id;
					}
					if (variantId) {
						fetch(_this10.variant_base + variantId).then(handleErrors).then(function (data) {
							return data.json();
						}).then(function (data) {
							_this10.setState({
								actualQuantity: data.variant.inventory_quantity
							});
						});
					}
				}).catch(catchErrors);
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.abortController.abort();
		}
	}, {
		key: 'render',
		value: function render() {
			var data = this.props.data;
			var _state2 = this.state,
			    price = _state2.price,
			    quantityInput = _state2.quantityInput,
			    actualQuantity = _state2.actualQuantity;

			var url = '/products/' + data.partNumber;
			var quantity = actualQuantity != undefined ? actualQuantity : data.quantity;
			return React.createElement(
				'div',
				{ className: 'partCardOuter' },
				React.createElement(
					'div',
					{ className: 'partCard' },
					React.createElement(
						'div',
						{ className: 'desc' },
						React.createElement(
							'a',
							{ href: url },
							data.description
						)
					),
					React.createElement(
						'div',
						{ className: 'cardDetailsRow' },
						React.createElement(
							'div',
							{ className: 'detailsLabel' },
							'Ref #'
						),
						React.createElement(
							'div',
							{ className: 'refNum' },
							data.referenceNumber
						)
					),
					React.createElement(
						'div',
						{ className: 'cardDetailsRow' },
						React.createElement(
							'div',
							{ className: 'detailsLabel' },
							'Part #'
						),
						React.createElement(
							'div',
							{ className: 'partNum' },
							data.partNumber
						)
					),
					React.createElement(
						'div',
						{ className: 'cardDetailsRow' },
						React.createElement(
							'div',
							{ className: 'detailsLabel' },
							'Quantity'
						),
						React.createElement(
							'div',
							{ className: 'quantity' },
							price ? React.createElement('input', {
								type: 'number',
								min: '1',
								value: quantityInput,
								onChange: this.updateQuantity
							}) : 'NA'
						)
					),
					React.createElement(
						'div',
						{ className: 'cardDetailsRow' },
						React.createElement(
							'div',
							{ className: 'detailsLabel' },
							'Stock Status'
						),
						React.createElement(
							'div',
							{ className: 'stockStatus' },
							price ? quantity > 0 ? "In Stock" : "Available" : 'NA'
						)
					),
					React.createElement(
						'div',
						{ className: 'cardDetailsRow' },
						React.createElement(
							'div',
							{ className: 'detailsLabel' },
							'Price'
						),
						React.createElement(
							'div',
							{ className: 'price' },
							price ? formatMoney(price) : 'NA'
						)
					),
					React.createElement(
						'div',
						{ className: 'addToCartContainer' },
						React.createElement(
							'div',
							{ className: 'addToCart' },
							price && React.createElement('input', {
								id: 'addToCart',
								type: 'button',
								value: 'Add to Cart',
								onClick: this.addToCart
							})
						)
					)
				)
			);
		}
	}]);

	return PartMobile;
}(React.Component);

var PartFinderBRP = function (_BaseFinder) {
	_inherits(PartFinderBRP, _BaseFinder);

	function PartFinderBRP(props) {
		_classCallCheck(this, PartFinderBRP);

		var _this11 = _possibleConstructorReturn(this, (PartFinderBRP.__proto__ || Object.getPrototypeOf(PartFinderBRP)).call(this, props));

		_this11.base = "https://api-brp.seawaymarine.com/brp/brp-db/public/index.php";
		_this11.yearPath = "/years/";
		_this11.horsepowersPath = '/horsepowers/';
		_this11.modelNumbersPath = '/model-numbers/';
		_this11.engineComponentPath = '/components/';
		_this11.partsPath = "/parts/";
		_this11.queryParams = ["year", "horsepower", "model-description", "engine-component"];
		_this11.queryParamLabels = ["Year", "Horsepower", "Model Description", "Engine Component", "Parts"];
		_this11.orderedPreOptionsHooks = [null, null, function (options) {
			return options.map(function (each) {
				var modelNumber = Object.values(each)[0].modelNumber;

				return modelNumber;
			});
		}, null];
		_this11.paramStateMap = {
			"year": "selectedYear",
			"horsepower": "selectedHorsepowers",
			"model-description": "selectedModelNumber",
			"engine-component": "selectedComponent"
		};
		_this11.paramStateMapReversal = reverseMap(_this11.paramStateMap);
		_this11.state = {
			selectedYear: null,
			selectedHorsepowers: null,
			selectedModelNumber: null,
			selectedComponent: null,
			queryString: window.location.search
		};

		_this11._ignoreCookies = function () {
			var queryString = window.location.search;
			var urlParams = new URLSearchParams(queryString);
			return urlParams.has('no-cookie');
		};

		_this11._checkParams = function () {
			var queryString = window.location.search;
			var urlParams = new URLSearchParams(queryString);
			var maxFoundInARow = 0;
			var continueCounting = true;
			var foundParams = {};
			_this11.queryParams.forEach(function (each, ind) {
				if (urlParams.get(each) && continueCounting) {
					maxFoundInARow++;
				} else {
					continueCounting = false;
				}
				foundParams[each] = urlParams.get(each);
			});
			foundParams['maxFoundInARow'] = maxFoundInARow;
			return foundParams;
		};

		_this11._parseSafe = function (item) {
			if (item && typeof item === 'string') {
				try {
					return JSON.parse(item);
				} catch (err) {
					return null;
				}
			}
			return null;
		};

		_this11._getOrderedIndex = function () {
			var continue_adding = true;
			var i = 0;
			_this11.queryParams.forEach(function (each, ind) {
				var current_state_item_name = _this11.paramStateMap[each];
				var current_state_item = _this11.state[current_state_item_name];
				if (current_state_item && current_state_item.value !== NULL_STRING && continue_adding) {
					i++;
				} else {
					continue_adding = false;
				}
			});
			return i;
		};

		_this11.updateURL = function () {
			var urlParams = new URLSearchParams();
			var continue_adding = true;
			_this11.queryParams.forEach(function (each) {
				var current_state_item_name = _this11.paramStateMap[each];
				var current_state_item = _this11.state[current_state_item_name];
				if (current_state_item && current_state_item.value !== NULL_STRING && continue_adding) {
					var readyValue = _this11.prepareValuesForURL(current_state_item);
					urlParams.append(each, readyValue);
				} else {
					continue_adding = false;
				}
			});
			var str = "";
			var queryString = "";
			if (urlParams.toString() !== "") {
				str = location.pathname + "?" + urlParams.toString();
				queryString = "?" + urlParams.toString();
			} else {
				str = location.pathname;
			}
			window.history.replaceState(null, "", str);
			_this11.setState({
				queryString: queryString
			});
		};

		_this11.prepareValuesForURL = function (values) {
			if (!values) return '';
			if (values.value !== values.text) {
				return values.value + URL_DELIMETER + values.text;
			} else {
				return values.value;
			}
		};

		_this11.prepareQueryParamForState = function (paramString) {
			// split string on delimiter
			var splitString = paramString.split(URL_DELIMETER);
			var value = "";
			var text = "";
			if (splitString.length > 1) {
				value = splitString[0];
				text = splitString[1];
			} else {
				value = splitString[0];
				text = splitString[0];
			}
			return {
				value: value,
				text: text
			};
		};

		_this11.getHorsepowersUrl = function () {
			var selectedYear = _this11.state.selectedYear;

			var horsepowersUrl = selectedYear ? _this11.base + _this11.horsepowersPath + _this11.num + ',' + selectedYear.value : null;
			return horsepowersUrl;
		};

		_this11.getModelNumbersUrl = function () {
			var _this11$state = _this11.state,
			    selectedYear = _this11$state.selectedYear,
			    selectedHorsepowers = _this11$state.selectedHorsepowers;

			var modelNumbersUrl = selectedYear && selectedHorsepowers ? _this11.base + _this11.modelNumbersPath + _this11.num + '|' + selectedYear.value + '|' + selectedHorsepowers.value : null;
			return modelNumbersUrl;
		};

		_this11.getComponentUrl = function () {
			var _this11$state2 = _this11.state,
			    selectedYear = _this11$state2.selectedYear,
			    selectedHorsepowers = _this11$state2.selectedHorsepowers,
			    selectedModelNumber = _this11$state2.selectedModelNumber;

			var componentUrl = selectedYear && selectedHorsepowers && selectedModelNumber ? _this11.base + _this11.engineComponentPath + _this11.num + '|' + selectedYear.value + '|' + selectedModelNumber.value : null;
			return componentUrl;
		};

		_this11.getMasterUrl = function () {
			var _this11$state3 = _this11.state,
			    selectedYear = _this11$state3.selectedYear,
			    selectedHorsepowers = _this11$state3.selectedHorsepowers,
			    selectedModelNumber = _this11$state3.selectedModelNumber,
			    selectedComponent = _this11$state3.selectedComponent;

			var masterUrl = selectedYear && selectedHorsepowers && selectedModelNumber && selectedComponent ? _this11.base + _this11.partsPath + _this11.num + '|' + selectedYear.value + '|' + selectedModelNumber.value + '|' + selectedComponent.value : null;
			return masterUrl;
		};

		_this11.getYearUrl = function () {
			return _this11.base + _this11.yearPath + _this11.brandID;
		};

		_this11.orderedUrlFunctions = [_this11.getYearUrl, _this11.getHorsepowersUrl, _this11.getModelNumbersUrl, _this11.getComponentUrl, function () {
			return null;
		}];

		_this11.brandID = _this11.props.config.brandID;
		_this11.num = _this11.props.config.num;
		return _this11;
	}

	// order matters


	// API BRP


	_createClass(PartFinderBRP, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			// check for cookies
			// set them in state
			// pass them down to select's

			var foundParams = this._checkParams();
			if (foundParams.maxFoundInARow > 0 || this._ignoreCookies()) {
				var newState = {};
				for (var i = 0; i < foundParams.maxFoundInARow; i++) {
					var param = this.queryParams[i];
					var paramValues = foundParams[param];
					var stateValue = this.prepareQueryParamForState(paramValues);
					newState[this.paramStateMap[param]] = stateValue;
				}
				this.setState(newState);
			} else {
				var vendor = this.props.config.vendor;

				var selectedYear = accessCookie(getCookieName(vendor, 'selectedYear'));
				var selectedHorsepowers = accessCookie(getCookieName(vendor, 'selectedHorsepowers'));
				var selectedModelNumber = accessCookie(getCookieName(vendor, 'selectedModelNumber'));
				var selectedComponent = accessCookie(getCookieName(vendor, 'selectedComponent'));

				selectedYear = this._parseSafe(selectedYear);
				selectedHorsepowers = this._parseSafe(selectedHorsepowers);
				selectedModelNumber = this._parseSafe(selectedModelNumber);
				selectedComponent = this._parseSafe(selectedComponent);

				this.setState({
					selectedYear: selectedYear,
					selectedHorsepowers: selectedHorsepowers,
					selectedModelNumber: selectedModelNumber,
					selectedComponent: selectedComponent
				}, this.updateURL);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var index = this._getOrderedIndex();
			var url = this.orderedUrlFunctions[index]();
			var hook = this.orderedPreOptionsHooks[index];
			var name = this.queryParams[index];
			var label = this.queryParamLabels[index];
			return React.createElement(
				'div',
				{ className: 'partFinder' },
				React.createElement(
					'div',
					{ className: 'breadcrumb' },
					this._getBreadCrumb()
				),
				this._getOrderedIndex() < this.queryParams.length ? React.createElement(LinkList, {
					queryString: this.state.queryString,
					index: index,
					url: url,
					preOptionsHook: hook,
					name: name,
					label: label
				}) : null,
				React.createElement(PartsDisplay, {
					api: this.props.config.api,
					url: this.getMasterUrl()
				})
			);
		}
	}]);

	return PartFinderBRP;
}(BaseFinder);

var PartFinder2 = function (_BaseFinder2) {
	_inherits(PartFinder2, _BaseFinder2);

	function PartFinder2(props) {
		_classCallCheck(this, PartFinder2);

		var _this12 = _possibleConstructorReturn(this, (PartFinder2.__proto__ || Object.getPrototypeOf(PartFinder2)).call(this, props));

		_this12.base = "https://api-brp.seawaymarine.com/seaway-db/public/index.php";
		_this12.modelsPath = "/model-numbers/";
		_this12.rangesPath = "/serial-ranges/";
		_this12.sectionsPath = "/sections/";
		_this12.partsPath = "/parts/";
		_this12.imagePath = "/main-image/";
		_this12.queryParams = ["model-description", "serial-range", "engine-component"];
		_this12.queryParamLabels = ["Model Description", "Serial Range", "Engine Component", "Parts"];
		_this12.orderedPreOptionsHooks = [function (options) {
			return options.map(function (each) {
				var modelNumber = Object.values(each)[0].modelNumber;

				return { value: modelNumber, text: modelNumber };
			});
		}, function (options) {
			return options.map(function (each) {
				var key = Object.keys(each)[0];
				var serialText = Object.values(each)[0].serialText;

				return {
					valueOverride: key,
					labelOverride: serialText
				};
			});
		}, function (options) {
			return options.map(function (each) {
				var key = Object.keys(each)[0];
				var _Object$values$ = Object.values(each)[0],
				    description = _Object$values$.description,
				    imageFile = _Object$values$.imageFile;

				return {
					valueOverride: key,
					labelOverride: description,
					extraData: imageFile
				};
			});
		}];
		_this12.paramStateMap = {
			"model-description": "selectedModelNumber",
			"serial-range": "selectedRange",
			"engine-component": "selectedComponent"
		};
		_this12.paramStateMapReversal = reverseMap(_this12.paramStateMap);
		_this12.state = {
			selectedModelNumber: null,
			selectedRange: null,
			selectedComponent: null,
			imageData: null,
			queryString: window.location.search,
			imageFilesUrl: "",
			imagePath: ''
		};

		_this12._ignoreCookies = function () {
			var queryString = window.location.search;
			var urlParams = new URLSearchParams(queryString);
			return urlParams.has('no-cookie');
		};

		_this12._checkParams = function () {
			var queryString = window.location.search;
			var urlParams = new URLSearchParams(queryString);
			var maxFoundInARow = 0;
			var continueCounting = true;
			var foundParams = {};
			_this12.queryParams.forEach(function (each, ind) {
				if (urlParams.get(each) && continueCounting) {
					maxFoundInARow++;
				} else {
					continueCounting = false;
				}
				foundParams[each] = urlParams.get(each);
			});
			foundParams['maxFoundInARow'] = maxFoundInARow;
			return foundParams;
		};

		_this12._parseSafe = function (item) {
			if (item && typeof item === 'string') {
				try {
					return JSON.parse(item);
				} catch (err) {
					return null;
				}
			}
			return null;
		};

		_this12._getOrderedIndex = function () {
			var continue_adding = true;
			var i = 0;
			_this12.queryParams.forEach(function (each, ind) {
				var current_state_item_name = _this12.paramStateMap[each];
				var current_state_item = _this12.state[current_state_item_name];
				if (current_state_item && current_state_item.value !== NULL_STRING && continue_adding) {
					i++;
				} else {
					continue_adding = false;
				}
			});
			return i;
		};

		_this12.updateURL = function () {
			var urlParams = new URLSearchParams();
			var continue_adding = true;
			_this12.queryParams.forEach(function (each) {
				var current_state_item_name = _this12.paramStateMap[each];
				var current_state_item = _this12.state[current_state_item_name];
				if (current_state_item && current_state_item.value !== NULL_STRING && continue_adding) {
					var readyValue = _this12.prepareValuesForURL(current_state_item);
					urlParams.append(each, readyValue);
				} else {
					continue_adding = false;
				}
			});
			var str = "";
			var queryString = "";
			if (urlParams.toString() !== "") {
				str = location.pathname + "?" + urlParams.toString();
				queryString = "?" + urlParams.toString();
			} else {
				str = location.pathname;
			}
			window.history.replaceState(null, "", str);
			_this12.setState({
				queryString: queryString
			});
		};

		_this12.prepareValuesForURL = function (values) {
			if (!values) return '';
			if (values.value !== values.text) {
				return values.value + URL_DELIMETER + values.text;
			} else {
				return values.value;
			}
		};

		_this12.prepareQueryParamForState = function (paramString) {
			// split string on delimiter
			var splitString = paramString.split(URL_DELIMETER);
			var value = "";
			var text = "";
			if (splitString.length > 1) {
				value = splitString[0];
				text = splitString[1];
			} else {
				value = splitString[0];
				text = splitString[0];
			}
			return {
				value: value,
				text: text
			};
		};

		_this12.getRangeUrl = function () {
			if (_this12.state.selectedModelNumber) {
				var modelNumber = _this12.state.selectedModelNumber.value.replace(/\//g, '!$');
				var rangeUrl = _this12.base + _this12.rangesPath + modelNumber;
				var rangeUrlEncoded = encodeURI(rangeUrl);
				return encodeURI(rangeUrl);
			}
			return null;
		};

		_this12.updateImageData = function () {
			var imageUrl = _this12.base + _this12.imagePath + _this12.state.selectedRange.value;
			fetch(imageUrl, { signal: _this12.signal }).then(handleErrors).then(function (data) {
				return data.json();
			}).then(function (data) {
				var keys = Object.keys(data);
				var imageUrl = _this12.base + _this12.sectionsPath + keys[0];
				_this12.setState({
					imageData: data,
					imageUrl: imageUrl
				}, function () {
					if (_this12.state.selectedComponent) {
						_this12.setImage();
					}
				});
			}).catch(catchErrors);
		};

		_this12.getComponentUrl = function () {
			var imageData = _this12.state.imageData;

			if (imageData) {
				var keys = Object.keys(imageData);
				var componentUrl = _this12.base + _this12.sectionsPath + keys[0];
				return componentUrl;
			}
			return null;
		};

		_this12.getMasterUrl = function () {
			if (_this12.state.selectedComponent) {
				var masterUrl = _this12.base + _this12.partsPath + _this12.state.selectedComponent.value;
				return masterUrl;
			}
			return null;
		};

		_this12.getModelUrl = function () {
			return _this12.base + _this12.modelsPath + _this12.brandID;
		};

		_this12.orderedUrlFunctions = [_this12.getModelUrl, _this12.getRangeUrl, _this12.getComponentUrl, function () {
			return null;
		}];

		_this12.setImage = function () {
			var _this12$state = _this12.state,
			    imageUrl = _this12$state.imageUrl,
			    selectedComponent = _this12$state.selectedComponent,
			    imageData = _this12$state.imageData;
			var value = selectedComponent.value;

			if (imageUrl) {
				var imageDataKeys = Object.keys(imageData);
				var pathArr = imageData[imageDataKeys[0]]['documentWorldviewFile'];
				var imagePath = pathArr.join('/');
				fetch(imageUrl).then(function (data) {
					return data.json();
				}).then(function (data) {
					var componentData = data.find(function (entry) {
						return Object.keys(entry)[0] === value;
					});
					var componentImageData = componentData[value];
					_this12.setState({
						imagePath: imagePath,
						componentImageData: componentImageData
					});
				});
			}
		};

		_this12.brandID = _this12.props.config.brandID;
		_this12.abortController = new AbortController();
		_this12.signal = _this12.abortController.signal;
		return _this12;
	}

	// order matters


	_createClass(PartFinder2, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this13 = this;

			var foundParams = this._checkParams();
			if (foundParams.maxFoundInARow > 0 || this._ignoreCookies()) {
				var newState = Object.assign({}, this.state);
				for (var i = 0; i < foundParams.maxFoundInARow; i++) {
					var param = this.queryParams[i];
					var paramValues = foundParams[param];
					var stateValue = this.prepareQueryParamForState(paramValues);
					newState[this.paramStateMap[param]] = stateValue;
				}
				this.setState(newState, function () {
					if (_this13.state.selectedRange && _this13.state.selectedRange.value) {
						_this13.updateImageData();
					}
				});
			} else {
				var vendor = this.props.config.vendor;

				var selectedModelNumber = accessCookie(getCookieName(vendor, 'selectedModelNumber'));
				var selectedRange = accessCookie(getCookieName(vendor, 'selectedRange'));
				var selectedComponent = accessCookie(getCookieName(vendor, 'selectedComponent'));

				selectedModelNumber = this._parseSafe(selectedModelNumber);
				selectedRange = this._parseSafe(selectedRange);
				selectedComponent = this._parseSafe(selectedComponent);

				this.setState({
					selectedModelNumber: selectedModelNumber,
					selectedRange: selectedRange,
					selectedComponent: selectedComponent
				}, function () {
					console.log('Partfinder state retrieved from cookies');
					_this13.updateURL();
				});
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.abortController.abort();
		}
	}, {
		key: 'render',
		value: function render() {
			var index = this._getOrderedIndex();
			var url = this.orderedUrlFunctions[index]();
			var hook = this.orderedPreOptionsHooks[index];
			var name = this.queryParams[index];
			var label = this.queryParamLabels[index];
			var showList = this._getOrderedIndex() < this.queryParams.length;
			var imagePath = this.state.imagePath;

			var image = null;
			if (!showList) {
				var componentImageData = this.state.componentImageData;

				if (componentImageData && componentImageData.imageFile) {
					image = imagePath + '/' + componentImageData.imageFile;
				}
			}

			return React.createElement(
				'div',
				{ className: 'partFinder' },
				React.createElement(
					'div',
					{ className: 'breadcrumb' },
					this._getBreadCrumb()
				),
				showList ? React.createElement(LinkList, {
					queryString: this.state.queryString,
					index: index,
					url: url,
					preOptionsHook: hook,
					name: name,
					label: label
				}) : null,
				React.createElement(PartsDisplay, {
					api: this.props.config.api,
					url: this.getMasterUrl(),
					imageName: image
				})
			);
		}
	}]);

	return PartFinder2;
}(BaseFinder);

var PartFinderYamaha = function (_BaseFinder3) {
	_inherits(PartFinderYamaha, _BaseFinder3);

	function PartFinderYamaha(props) {
		_classCallCheck(this, PartFinderYamaha);

		var _this14 = _possibleConstructorReturn(this, (PartFinderYamaha.__proto__ || Object.getPrototypeOf(PartFinderYamaha)).call(this, props));

		_this14.base = "https://api-yamaha.seawaymarine.com/yamaha/yamaha-db/public/index.php";
		_this14.yearPath = "/years/";
		_this14.horsepowersPath = '/horsepowers/';
		_this14.modelNumbersPath = '/model-numbers/';
		_this14.engineComponentPath = '/components/';
		_this14.partsPath = "/parts/";
		_this14.queryParams = ["year", "horsepower", "model-description", "engine-component"];
		_this14.queryParamLabels = ["Year", "Horsepower", "Model Description", "Engine Component", "Parts"];
		_this14.orderedPreOptionsHooks = [null, null, function (options) {
			return options.map(function (each) {
				var modelNumber = Object.values(each)[0].modelNumber;

				return modelNumber;
			});
		}, null];
		_this14.paramStateMap = {
			"year": "selectedYear",
			"horsepower": "selectedHorsepowers",
			"model-description": "selectedModelNumber",
			"engine-component": "selectedComponent"
		};
		_this14.paramStateMapReversal = reverseMap(_this14.paramStateMap);
		_this14.state = {
			selectedYear: null,
			selectedHorsepowers: null,
			selectedModelNumber: null,
			selectedComponent: null,
			queryString: window.location.search
		};

		_this14.getHorsepowersUrl = function () {
			var selectedYear = _this14.state.selectedYear;

			var horsepowersUrl = selectedYear ? _this14.base + _this14.horsepowersPath + _this14.brandID + ',' + selectedYear.value : null;
			return horsepowersUrl;
		};

		_this14.getModelNumbersUrl = function () {
			var _this14$state = _this14.state,
			    selectedYear = _this14$state.selectedYear,
			    selectedHorsepowers = _this14$state.selectedHorsepowers;

			var modelNumbersUrl = selectedYear && selectedHorsepowers ? _this14.base + _this14.modelNumbersPath + _this14.brandID + '|' + selectedYear.value + '|' + selectedHorsepowers.value : null;
			return modelNumbersUrl;
		};

		_this14.getComponentUrl = function () {
			var _this14$state2 = _this14.state,
			    selectedYear = _this14$state2.selectedYear,
			    selectedHorsepowers = _this14$state2.selectedHorsepowers,
			    selectedModelNumber = _this14$state2.selectedModelNumber;

			var componentUrl = selectedYear && selectedHorsepowers && selectedModelNumber ? _this14.base + _this14.engineComponentPath + _this14.brandID + '|' + selectedYear.value + '|' + selectedModelNumber.value : null;

			return componentUrl;
		};

		_this14.getMasterUrl = function () {
			var _this14$state3 = _this14.state,
			    selectedYear = _this14$state3.selectedYear,
			    selectedHorsepowers = _this14$state3.selectedHorsepowers,
			    selectedModelNumber = _this14$state3.selectedModelNumber,
			    selectedComponent = _this14$state3.selectedComponent;

			var masterUrl = selectedYear && selectedHorsepowers && selectedModelNumber && selectedComponent ? _this14.base + _this14.partsPath + _this14.brandID + '|' + selectedYear.value + '|' + selectedHorsepowers.value + '|' + selectedModelNumber.value + '|' + selectedComponent.value : null;
			return masterUrl;
		};

		_this14.getYearUrl = function () {
			return _this14.base + _this14.yearPath + _this14.brandID;
		};

		_this14.orderedUrlFunctions = [_this14.getYearUrl, _this14.getHorsepowersUrl, _this14.getModelNumbersUrl, _this14.getComponentUrl, function () {
			return null;
		}];

		_this14.brandID = _this14.props.config.brandID;
		_this14.num = _this14.props.config.num;
		return _this14;
	}

	// order matters


	// API BRP


	_createClass(PartFinderYamaha, [{
		key: 'render',
		value: function render() {
			var index = this._getOrderedIndex();
			var url = this.orderedUrlFunctions[index]();
			var hook = this.orderedPreOptionsHooks[index];
			var name = this.queryParams[index];
			var label = this.queryParamLabels[index];
			return React.createElement(
				'div',
				{ className: 'partFinder' },
				React.createElement(
					'div',
					{ className: 'breadcrumb' },
					this._getBreadCrumb()
				),
				this._getOrderedIndex() < this.queryParams.length ? React.createElement(LinkList, {
					queryString: this.state.queryString,
					index: index,
					url: url,
					preOptionsHook: hook,
					name: name,
					label: label
				}) : null,
				React.createElement(PartsDisplay, {
					api: this.props.config.api,
					url: this.getMasterUrl()
				})
			);
		}
	}]);

	return PartFinderYamaha;
}(BaseFinder);

var LinkList = function (_React$Component6) {
	_inherits(LinkList, _React$Component6);

	function LinkList(props) {
		_classCallCheck(this, LinkList);

		var _this15 = _possibleConstructorReturn(this, (LinkList.__proto__ || Object.getPrototypeOf(LinkList)).call(this, props));

		_this15.prepareValuesForURL = function (values) {
			if (!values) return '';
			if (values.value !== values.text) {
				return values.value + URL_DELIMETER + values.text;
			} else {
				return values.value;
			}
		};

		_this15.getHref = function (values) {
			var urlParams = new URLSearchParams(_this15.props.queryString);
			var readyValue = _this15.prepareValuesForURL(values);
			urlParams.append(_this15.props.name, readyValue);
			if (urlParams.toString() !== "") {
				str = location.pathname + "?" + urlParams.toString();
				queryString = "?" + urlParams.toString();
			} else {
				str = location.pathname;
			}
			return str;
		};

		_this15.getLabel = function () {
			return _this15.props.label;
		};

		_this15.abortController = new window.AbortController();
		_this15.signal = _this15.abortController.signal;
		_this15.state = {
			optionsJSX: null,
			filter: '',
			loading: true
		};
		return _this15;
	}

	_createClass(LinkList, [{
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevProps.url !== this.props.url || prevProps.preOptionsHook !== this.props.preOptionsHook) {
				this.getSelectOptions();
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.getSelectOptions();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.abortController.abort();
		}
	}, {
		key: 'getSelectOptions',
		value: function getSelectOptions() {
			var _this16 = this;

			this.setState({ loading: true });
			var url = this.props.url;
			if (url) {
				fetch(url, { signal: this.signal }).then(handleErrors).then(function (data) {
					return data.json();
				}).then(function (data) {
					_this16.getOptions(data, url);
				}).catch(catchErrors);
			} else {
				this.getOptions([]);
			}
		}
	}, {
		key: 'getOptions',
		value: function getOptions(options, url) {
			var _this17 = this;

			var preOptionsHook = this.props.preOptionsHook;

			var rawOptions = preOptionsHook ? preOptionsHook(options) : options;
			try {
				var reconfiguredOptions = rawOptions.map(function (option) {
					if (typeof option === 'string') {
						return {
							value: option,
							text: option
						};
					} else {
						return option;
					}
				});
				var filteredOptions = reconfiguredOptions.filter(function (option) {
					if (typeof option.value === 'string') {
						return option.text.toLowerCase().indexOf(_this17.state.filter.toLowerCase()) > -1;
					} else {
						return option.labelOverride.toLowerCase().indexOf(_this17.state.filter.toLowerCase()) > -1;
					}
				});
				var finalOptions = filteredOptions.map(function (each, ind) {
					if (typeof each.value === 'string') {
						var unique_index = each.value + ind;
						return React.createElement(
							'li',
							null,
							React.createElement(
								'a',
								{ key: unique_index, href: _this17.getHref(each) },
								each.text
							)
						);
					} else {
						var otherEach = {
							value: each.valueOverride.trim(),
							text: each.labelOverride
						};
						var _unique_index = each.labelOverride + ind;
						return React.createElement(
							'li',
							null,
							React.createElement(
								'a',
								{ key: _unique_index, href: _this17.getHref(otherEach) },
								each.labelOverride
							)
						);
					}
				});
				if (url !== this.props.url) {
					this.getSelectOptions();
				} else {
					this.setState({
						optionsJSX: finalOptions,
						loading: false
					});
				}
			} catch (error) {}
		}
	}, {
		key: 'render',
		value: function render() {
			return React.createElement(
				'div',
				{ className: 'linkList' },
				React.createElement(
					'h2',
					{ className: 'linkListTitle' },
					this.getLabel()
				),
				React.createElement(
					'ul',
					null,
					this.state.loading ? React.createElement('div', { className: 'spinner' }) : this.state.optionsJSX
				)
			);
		}
	}]);

	return LinkList;
}(React.Component);

var Switcher = function (_React$Component7) {
	_inherits(Switcher, _React$Component7);

	function Switcher() {
		_classCallCheck(this, Switcher);

		return _possibleConstructorReturn(this, (Switcher.__proto__ || Object.getPrototypeOf(Switcher)).apply(this, arguments));
	}

	_createClass(Switcher, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			createSiteCookie('seaway_last_partfinder_vendor', this.props.config.vendor);
			createSiteCookie('seaway_last_partfinder_url', window.location);
		}
	}, {
		key: 'render',
		value: function render() {
			var config = this.props.config;

			switch (config.api) {
				case 'brp':
					return React.createElement(PartFinderBRP, { config: config });
				case 'partfinder2':
					return React.createElement(PartFinder2, { config: config });
				case 'yamaha':
					return React.createElement(PartFinderYamaha, { config: config });
			}
		}
	}]);

	return Switcher;
}(React.Component);

/* 
	This is the root element id which
	determines where the little
	React app will be loaded
*/


var renderPartFinder = function renderPartFinder() {
	var rootElementId = "#part-finder";
	var rootElement = document.querySelector(rootElementId);
	var vendor = rootElement.getAttribute('data-vendor');
	var title = rootElement.getAttribute('data-title');
	var configMap = {
		yamaha: {
			vendor: 'yamaha',
			api: 'yamaha',
			brandID: 1
		},
		electric: {
			vendor: 'electric',
			api: 'brp',
			brandID: 2,
			num: 22
		},
		evinrude: {
			vendor: 'evinrude',
			api: 'brp',
			brandID: 3,
			num: 20
		},
		johnson: {
			vendor: 'johnson',
			api: 'brp',
			brandID: 4,
			num: 24
		},
		quietrider: {
			vendor: 'quietrider',
			api: 'brp',
			brandID: 5,
			num: 26
		},
		sterndrive: {
			vendor: 'sterndrive',
			api: 'brp',
			brandID: 6,
			num: 28
		},
		turbojet: {
			vendor: 'turbojet',
			api: 'brp',
			brandID: 7,
			num: 30
		},
		mercruiser: {
			vendor: 'mercruiser',
			api: 'partfinder2',
			brandID: 8
		},
		mercury: {
			vendor: 'mercury',
			api: 'partfinder2',
			brandID: 9
		},
		mariner: {
			vendor: 'mariner',
			api: 'partfinder2',
			brandID: 6
		},
		force: {
			vendor: 'force',
			api: 'partfinder2',
			brandID: 4
		},
		chrysler: {
			vendor: 'chrysler',
			api: 'partfinder2',
			brandID: 3
		}
	};
	var config = configMap[vendor];
	config['title'] = title;
	ReactDOM.unmountComponentAtNode(rootElement);
	ReactDOM.render(React.createElement(Switcher, { config: config }), rootElement);
};
addLoadEvent(renderPartFinder);

/* Utilities */
function formatMoney(amount) {
	if (!amount) return '';
	var options = {
		style: 'currency',
		currency: 'USD',
		minimumFractionDigits: 2
	};
	// if its a whole, dollar amount, leave off the .00
	if (amount % 100 === 0) options.minimumFractionDigits = 0;
	var formatter = new Intl.NumberFormat('en-US', options);
	var final = formatter.format(amount / 100);
	return final;
}
function handleErrors(response) {
	if (!response.ok) {
		throw Error(response.statusText);
	}
	return response;
}
function catchErrors(error) {}
function createCookie(cookieName, cookieValue) {
	var date = new Date();
	date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
	var cookie = cookieName + "=" + cookieValue; // + ";expires=" + date.toGMTString();
	document.cookie = cookie;
	return accessCookie(cookieName);
}
function createSiteCookie(cookieName, cookieValue) {
	var date = new Date();
	date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
	var cookie = cookieName + "=" + cookieValue + ';path=/'; // + ";expires=" + date.toGMTString();
	document.cookie = cookie;
	return accessCookie(cookieName);
}
function accessCookie(cookieName) {
	var name = cookieName + "=";
	var cookieString = document.cookie;
	var allCookieArray = cookieString.split(';');
	for (var i = 0; i < allCookieArray.length; i++) {
		var temp = allCookieArray[i].trim();
		if (temp.indexOf(name) == 0) return temp.substring(name.length, temp.length);
	}
	return "";
}
function getCookieName(vendor, inputName) {
	return vendor + "" + inputName;
}
function addLoadEvent(func) {
	var oldonload = window.onload;
	if (typeof window.onload != 'function') {
		window.onload = func;
	} else {
		window.onload = function () {
			if (oldonload) {
				oldonload();
			}
			func();
		};
	}
}
function reverseMap(map) {
	var newMap = {};
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = Object.entries(map)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var _ref3 = _step.value;

			var _ref4 = _slicedToArray(_ref3, 2);

			var key = _ref4[0];
			var value = _ref4[1];

			newMap[value] = key;
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	return newMap;
}